import { WarningTriangleIcon } from '@va/icons';
import { Chip } from '../../../chip';

export const LimitReachedChip = ({ label }: { label: string }) => {
  return (
    <Chip
      className='rounded-full! bg-orange-pure! text-white'
      size='small'
      icon={<WarningTriangleIcon className='w-15px h-15px' />}
    >
      {label}
    </Chip>
  );
};
